<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container pt-4">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">
          {{ showSetPassView ? 'Set your password' : 'Forgot password' }}
        </h1>
      </div>
    </div>

    <div *ngIf="showSetPassView" class="row mb-4">
      <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
        <h6 class="text-center">
          We've made a few changes to the site, so we'll need you to set a new password.
          Please enter your email below.
        </h6>
      </div>
    </div>

    <div class="row pb-5">
      <div class="col-md-4 offset-md-4 mb-3">

        <form #forgotPasswordForm="ngForm" (ngSubmit)="forgotPassword()" novalidate>
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div class="row mb-1 px-3" [ngClass]="'justify-content-end'">
              <div class="w-auto px-0">
                <mat-slide-toggle class="chip-checkbox" [checked]="authWithChipNumber" (change)="onAuthWithChipNumberChanged($event)">Use chip number</mat-slide-toggle>
              </div>
            </div>
            <label class="form-label" for="email">{{ authWithChipNumber ? 'Chip number' : 'Email address'}}</label>
            <input #email="ngModel"
                    class="form-control"
                    [class.is-invalid]="email.touched && !email.valid"
                    name="email"
                    [(ngModel)]="model.identifier"
                    [placeholder]="authWithChipNumber ? 'Enter chip number' : 'Enter email'"
                    (ngModelChange)="closeAlert()"
                    required
                    type="text">
            <div *ngIf="email.errors &&
                        email.errors.required"
                  class="invalid-feedback">
              {{ errorStrings.required }}
            </div>
          </div>
          <button type="submit"
                  class="btn btn-success text-white btn-lg w-100 mt-5"
                  [disabled]="!forgotPasswordForm.valid || loading">
            <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
            {{ loading ? 'Resetting...' : 'Reset Password' }}
          </button>

        </form>

      </div>
    </div>
  </div>
</div>